import type { Locale } from '@eneco/common/application';

import { getFormatter } from './formatters';
import type { MessageContext } from './types';

export const format = (message: string, locale: Locale, context: MessageContext = {}): string => {
  const formatter = getFormatter(locale);
  return formatter.format(message, context);
};
